import { render, staticRenderFns } from "./ListPostCommentForm.vue?vue&type=template&id=d161c5b2&"
import script from "./ListPostCommentForm.vue?vue&type=script&lang=js&"
export * from "./ListPostCommentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports